import React from "react";
import { Film, Download } from "lucide-react";
import { absUrl, saveImage } from "./_helpers";

// Strip of pre-rendered Sora 2 reel videos at the top of the kit page.
// Hidden when no videos are ready.
export default function ReelsStrip({ videos }) {
    const ready = (videos || []).filter(v => v?.status === "ready" && v?.url);
    if (!ready.length) return null;

    const downloadVideo = async (v) => {
        const fname = `reel-${v.reel}-${(v.title || "cafe").toLowerCase().replace(/\s+/g, "-")}.mp4`;
        await saveImage(absUrl(v.url), fname);
    };

    return (
        <section className="mb-16" data-testid="reels-strip">
            <div className="flex items-center gap-3 mb-6">
                <Film className="w-5 h-5 text-cafe-terracotta" />
                <h2 className="font-serif text-2xl sm:text-3xl text-cafe-espresso">
                    {ready.length} ready-made Reel{ready.length > 1 ? "s" : ""}
                </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                {ready.map(v => (
                    <figure key={v.reel} className="rounded-2xl overflow-hidden bg-cafe-espresso aspect-[9/16] relative group" data-testid={`reel-${v.reel}`}>
                        <video src={absUrl(v.url)} controls playsInline preload="metadata" className="w-full h-full object-cover" />
                        <button
                            onClick={() => downloadVideo(v)}
                            className="absolute top-2 right-2 w-8 h-8 rounded-full bg-cafe-cream/90 hover:bg-cafe-cream text-cafe-espresso flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                            title="Save video"
                            data-testid={`reel-${v.reel}-save`}
                        >
                            <Download className="w-3.5 h-3.5" />
                        </button>
                        <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-cafe-espresso/90 to-transparent text-cafe-cream px-3 py-2 text-[10px] uppercase tracking-[0.15em]">
                            Reel {v.reel} · {v.title || "Cafe vibe"}
                        </figcaption>
                    </figure>
                ))}
            </div>
        </section>
    );
}
